import React from "react"

class Restaurant extends React.Component {

    componentDidMount() {
       
    }

    render() {
        return (
            <div>
                <h3>Szczegóły pojedynczej restauracji</h3>

                <div>todo</div>
            </div>
        )
    }
}

export default Restaurant;